// extracted by mini-css-extract-plugin
module.exports = {"contactDetailsPage":"styles_contactDetailsPage__2epGT","body":"styles_body__2W7_I","emptyPage":"styles_emptyPage__3KoJb"};